<template>
    <div class="row mb-2">
        <div class="col-lg-3 col-md-6 col-12">
            <mini-statistics-card title="Horas Registradas Hoy" :value="stats.day_total_hours.toFixed(1) + ' hrs'"
                :description="today" :icon="{
                    component: 'ni ni-time-alarm',
                    background: 'bg-gradient-primary',
                    shape: 'rounded-circle',
                }" />
        </div>
        <div class="col-lg-3 col-md-6 col-12">
            <mini-statistics-card title="Horas registradas esta semana" :value="stats.week_total_hours.toFixed(1) + ' hrs'"
                :description="weekRange" :icon="{
                    component: 'ni ni-time-alarm',
                    background: 'bg-gradient-warning',
                    shape: 'rounded-circle',
                }" />
        </div>
        <div class="col-lg-3 col-md-6 col-12">
            <mini-statistics-card title="Horas Extra" :value="stats.week_extra_hours.toFixed(1) + ' hrs'"
                description="En esta semana." :icon="{
                    component: 'ni ni-money-coins',
                    background: 'bg-gradient-success',
                    shape: 'rounded-circle',
                }" />
        </div>
        <div class="col-lg-3 col-md-6 col-12">
            <mini-statistics-card title="Horas en planta" :value="stats.week_on_site_hours.toFixed(1) + ' hrs'"
                description="En esta semana." :icon="{
                    component: 'ni ni-pin-3',
                    background: 'bg-gradient-danger',
                    shape: 'rounded-circle',
                }" />
        </div>
    </div>
</template>

<script setup>

import axios from 'axios';
import { ref, onMounted } from 'vue';
import MiniStatisticsCard from "@/examples/Cards/MiniStatisticsCard.vue";
const API_BASE_URL = process.env.VUE_APP_BASE_URL;
const token = localStorage.getItem('authToken'); // Obtén el token del localStorage

const today = new Date().toLocaleDateString("es-MX", {
    day: "numeric",
    month: "long"
});

// Función para obtener el rango de la semana (lunes a domingo)
const getWeekRange = () => {
    const today = new Date();
    today.setHours(0.0, 0.0, 0.0, 0.0);

    // Ajustar la zona horaria a CDMX
    const options = { timeZone: "America/Mexico_City", day: "numeric", month: "long" };

    // Obtener el lunes de la semana actual
    const dayOfWeek = today.getDay(); // 0 = Domingo, 1 = Lunes, ..., 6 = Sábado
    const monday = new Date(today);
    monday.setDate(today.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1));

    // Obtener el domingo de la misma semana
    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);

    // Formatear las fechas en español
    const startDate = monday.toLocaleDateString("es-MX", options);
    const endDate = sunday.toLocaleDateString("es-MX", options);

    return `Del ${startDate} al ${endDate}`;
};

const weekRange = ref(getWeekRange());

const stats = ref({
    day_total_hours: 0,
    week_total_hours: 0,
    week_extra_hours: 0,
    week_on_site_hours: 0,
})

const loadStatsData = async () => {

    const options = { timeZone: "America/Mexico_City", year: "numeric", month: "2-digit", day: "2-digit" };
    // Obtener la fecha de hoy en CDMX
    const today = new Date().toLocaleDateString("fr-CA", options); // Formato YYYY-MM-DD
    // Obtener el lunes de la semana actual
    const now = new Date();
    const dayOfWeek = now.getDay(); // 0 = Domingo, 1 = Lunes, ..., 6 = Sábado
    const mondayOffset = dayOfWeek === 0 ? -6 : 1 - dayOfWeek; // Si es domingo, retroceder 6 días, si no, ir a lunes
    const startDate = new Date(now.setDate(now.getDate() + mondayOffset)).toLocaleDateString("fr-CA", options);
    // Obtener el domingo de la semana actual
    const endDate = new Date(now.setDate(now.getDate() + 6)).toLocaleDateString("fr-CA", options);

    const body = {
        start_date: startDate,
        end_date: endDate,
        today: today
    };

    try {
        const response = await axios.post(`${API_BASE_URL}/user-time-stats`, body, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        stats.value = Object.fromEntries(
            Object.entries(response.data[0]).map(([key, value]) => [key, value ?? 0])
        );
    } catch (error) {
        console.error('Error al obtener los datos:', error);
    }
}

// Inicializa el DataTable después de obtener los datos
onMounted(async () => {
    await loadStatsData()
});
</script>